<template>
  <div
    class="flex border border-b-0 border-gray-700 select-none layer-list-item"
    :class="{ 'selected-in-panel': selectedInPanel, visible, disabled, focused, 'selected-in-scene': selectedInScene }"
  >
    <VTooltip v-if="disabled" hide-on-breakpoint="sm" direction="right" class="h-full z-20">
      <template #content>
        <div class="whitespace-nowrap">
          <span>You cannot hide individual drill holes</span>
        </div>
      </template>
      <EditorDeckSlidesThreeDVisibilityIcon :visible="visible" />
    </VTooltip>
    <div
      v-else
      ref="visibilityToggle"
      class="border-r border-gray-700 layer-icon"
      data-intercom-target="visibility-icon"
      @contextmenu.stop=""
    >
      <slot name="visibility">
        <EditorDeckSlidesThreeDVisibilityIcon :visible="visible" />
      </slot>
    </div>
    <div
      class="relative flex self-stretch flex-1 w-full pr-1"
      @click="$emit('click', $event)"
      @mouseover="$emit('mouseover', $event)"
      @mouseleave="$emit('mouseleave', $event)"
      @contextmenu="$emit('contextmenu', $event)"
    >
      <div class="absolute inset-0 top-0 pointer-events-none selected-layer-border" />
      <div class="flex items-center w-full h-full text-sm layer-title-container">
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  selectedInPanel: {
    type: Boolean,
    default: false,
  },
  focused: {
    type: Boolean,
    default: false,
  },
  selectedInScene: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['click', 'mouseenter', 'mouseleave', 'mouseover', 'contextmenu', 'set-visible'])

const visibilityToggle = ref<HTMLElement | null>(null)

useMouseOverVisibilityToggle({
  toggleRef: visibilityToggle,
  visible: toRef(props, 'visible'),
  setVisible: value => !props.disabled && emit('set-visible', value),
})
</script>

<style lang="stylus" scoped>
.layer-list-item.selected-in-scene .selected-layer-border
  @apply bg-opacity-30 border border-copper-200
.layer-list-item.selected-in-panel .selected-layer-border
  @apply bg-copper-200 bg-opacity-30 border border-copper-200

.layer-list-item:hover .selected-layer-border
  @apply border border-copper-200

.layer-list-item:not(.visible)
  .layer-icon, &:not(.focused) .layer-title-container
    @apply opacity-60

.layer-list-item.disabled
  :deep(.visibility-icon svg)
    @apply cursor-not-allowed

.layer-icon
  touch-action none
</style>
